import {
  Stethoscope,
  Building,
  Home,
  UtensilsCrossed,
  Briefcase,
  Megaphone,
  Code,
  ShoppingBag,
  Hammer,
  MapPin,
} from "lucide-react";

const sectors = [
  {
    icon: Stethoscope,
    title: "Secteur médical",
    description: "Cabinets médicaux, dentistes, physiothérapeutes",
  },
  {
    icon: Building,
    title: "Architecture & ingénierie",
    description: "Bureaux d'architectes, ingénieurs, géomètres",
  },
  {
    icon: Home,
    title: "Home office & freelances",
    description: "Travailleurs indépendants à domicile",
  },
  {
    icon: UtensilsCrossed,
    title: "Restauration & hôtellerie",
    description: "Restaurants, cafés, hôtels",
  },
  {
    icon: Briefcase,
    title: "Sociétés de consulting",
    description: "Conseil en management, stratégie, RH",
  },
  {
    icon: Megaphone,
    title: "Agences de marketing & communication",
    description: "Agences digitales, créatives, événementielles",
  },
  {
    icon: Code,
    title: "SaaS & startups",
    description: "Entreprises technologiques, éditeurs de logiciels",
  },
  {
    icon: ShoppingBag,
    title: "Commerce & retail",
    description: "Boutiques, e-commerce, distribution",
  },
  {
    icon: Hammer,
    title: "Artisanat & construction",
    description: "Entreprises du bâtiment, artisans, menuisiers",
  },
  {
    icon: MapPin,
    title: "Immobilier",
    description: "Régies, promoteurs, gestion de patrimoine",
  },
];

const Experience = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="experience"
      className="py-20 md:py-28 bg-gray-50"
      aria-labelledby="experience-title"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-left mb-12 md:mb-16">
          <h2
            id="experience-title"
            className="text-3xl md:text-4xl font-semibold text-gray-900 tracking-tight font-['Manrope']"
          >
            Des secteurs que nous connaissons
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl">
            Nous accompagnons des entreprises de tous horizons avec une expertise adaptée à chaque domaine
          </p>
        </div>

        {/* Sectors Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
          {sectors.map((sector, index) => (
            <div
              key={sector.title}
              className="sector-badge group flex flex-col items-center text-center p-5 md:p-6 bg-white border border-gray-200 rounded-xl"
              data-testid={`sector-badge-${index}`}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-blue-50 mb-3 group-hover:bg-blue-100 transition-colors">
                <sector.icon
                  className="w-5 h-5 text-blue-600"
                  strokeWidth={1.5}
                  aria-hidden="true"
                />
              </div>
              <h3 className="text-sm font-semibold text-gray-900 font-['Manrope'] mb-1">
                {sector.title}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed">
                {sector.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional text */}
        <div className="mt-10 md:mt-12 text-center">
          <p className="text-gray-600">
            Votre secteur n'est pas listé ?{" "}
            <a
              href="#contact"
              onClick={scrollToContact}
              className="text-blue-600 hover:text-blue-700 font-medium underline underline-offset-4"
              data-testid="experience-contact-link"
            >
              Contactez-nous
            </a>
            , nous nous adaptons à votre activité.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Experience;
